import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_details_income",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row mb-3" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "title-h4" }
const _hoisted_10 = { class: "position-relative" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { class: "row mb-3" }
const _hoisted_13 = { class: "col-md-12" }
const _hoisted_14 = { class: "title-h4" }
const _hoisted_15 = {
  key: 0,
  class: "tab-pane fade in active show",
  id: "income-payments",
  style: {"overflow-x":"auto"}
}
const _hoisted_16 = { class: "datatables table table-striped table-bordered" }
const _hoisted_17 = { class: "thead-dark" }
const _hoisted_18 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_informations_income = _resolveComponent("informations-income")!
  const _component_list_bilans = _resolveComponent("list-bilans")!
  const _component_list_bookings = _resolveComponent("list-bookings")!
  const _component_btn_delete = _resolveComponent("btn-delete")!
  const _component_not_found = _resolveComponent("not-found")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRequestPayment)
          ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.i18n.t('layout.sidbar.incomes.details')), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_details_income', 'view'))),
            type: "button",
            class: "btn-close",
            "aria-label": "btn-close"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.i18n.t('views.clients.income.payment.info')), 1)
            ])
          ]),
          _createVNode(_component_informations_income),
          (_ctx.hasPermission('view_member_bilans') && _ctx.income?.service_type == 'bilan')
            ? (_openBlock(), _createBlock(_component_list_bilans, {
                key: 0,
                bilans: _ctx.income?.bilans ?? [],
                income: _ctx.income,
                onSaved: _ctx.onIncomeUpdated,
                onEditBilan: _ctx.emitEditBilan
              }, null, 8, ["bilans", "income", "onSaved", "onEditBilan"]))
            : _createCommentVNode("", true),
          (_ctx.hasPermission('view_member_session_bookings') && _ctx.income?.service_type == 'coaching')
            ? (_openBlock(), _createBlock(_component_list_bookings, {
                key: 1,
                income: _ctx.income,
                onSaved: _ctx.onIncomeUpdated,
                onEditBooking: _ctx.emitEditBooking
              }, null, 8, ["income", "onSaved", "onEditBooking"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.i18n.t('views.clients.income.payment.paid')), 1)
              ])
            ]),
            (_ctx.incomesPaymentsList?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("table", _hoisted_16, [
                    _createElementVNode("thead", _hoisted_17, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.paymentDate')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.paymentMethod')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.chequeName')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.bankName')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.chequeNum')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.dueDate')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.amount_paid')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.action')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incomesPaymentsList, (transaction) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          value: "member.id",
                          key: transaction?.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(transaction?.paymentDate)), 1),
                          _createElementVNode("td", null, _toDisplayString(transaction.paymentMethod), 1),
                          _createElementVNode("td", null, _toDisplayString(transaction.chequeName), 1),
                          _createElementVNode("td", null, _toDisplayString(transaction?.bankName), 1),
                          _createElementVNode("td", null, _toDisplayString(transaction?.chequeNum), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(transaction?.dueDate)), 1),
                          _createElementVNode("td", null, _toDisplayString(transaction?.amount_paid ?? 0.00) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_btn_delete, {
                              onDelete: ($event: any) => (_ctx.Delete(transaction?.id))
                            }, null, 8, ["onDelete"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_not_found, {
                    text: _ctx.i18n.t('message.data_not_found.title'),
                    icon: "warning"
                  }, null, 8, ["text"])
                ]))
          ])
        ])
      ])
    ])
  ]))
}